enum PlanningOrderDriverPlanListingFilterType {
  ADDRESS = "ADDRESS",
  DRIVER_NAME = "DRIVER_NAME",
  CARGO_ORDER = "CARGO_ORDER",
  RESULT = "RESULT",
}

export default PlanningOrderDriverPlanListingFilterType;
